import { render, staticRenderFns } from "./StoType.vue?vue&type=template&id=54d11d6f"
import script from "./StoType.vue?vue&type=script&lang=js"
export * from "./StoType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports